import styled from '@emotion/styled'
import { Button } from 'components'
import { Input } from 'components/inputs'

const MenuItemInstructionsView = styled.div`
  width: 100%;
  padding: ${(props) => props.theme.layout.padding};
  background-color: ${(props) => props.theme.bgColors.tertiary};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: ${(props) => props.theme.layout.paddingMobile};
  }
`

const MenuItemInstructionsContainer = styled.div`
  border-radius: ${(props) => props.theme.border.radius};
  padding: ${(props) => props.theme.layout.padding};
  background-color: ${(props) => props.theme.bgColors.primary};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: ${(props) => props.theme.layout.paddingMobile};
  }
`

const MenuItemInstructionsInput = styled.div`
  width: 100%;
  margin: 0 0 2rem;

  label {
    margin: 0;
  }
`

const MenuItemInstructionsCounter = styled.p`
  margin: 0.5rem 0 0;
  text-align: right;
  font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  color: ${(props) => props.theme.colors.secondary};
`

const MenuItemInstructionsFooter = styled.div`
  margin: 3rem 0 0;
  text-align: center;
`

interface MenuItemInstructionsProps {
  hasMadeFor: boolean
  madeFor: string | null
  setMadeFor: (madeFor: string) => void
  hasNotes: boolean
  notes: string | null
  setNotes: (notes: string) => void
  allDone?: () => void
  notesLabel?: string
  notesPlaceholder?: string
  doneLabel?: string
  maxNotes?: number
}

const MenuItemInstructions = ({
  hasMadeFor,
  madeFor,
  setMadeFor,
  hasNotes,
  notes,
  setNotes,
  allDone,
  notesLabel = 'Any special instructions?',
  notesPlaceholder,
  doneLabel = 'All Done',
  maxNotes,
}: MenuItemInstructionsProps) => {
  return (
    <MenuItemInstructionsView>
      <MenuItemInstructionsContainer>
        {hasMadeFor && (
          <MenuItemInstructionsInput>
            <Input
              label="Who is this order for?"
              name="made-for"
              type="text"
              value={madeFor || ''}
              onChange={(evt) => setMadeFor(evt.target.value)}
            />
          </MenuItemInstructionsInput>
        )}
        {hasNotes && (
          <MenuItemInstructionsInput>
            <Input
              label={notesLabel}
              name="notes"
              type="text"
              value={notes || ''}
              onChange={(evt) => setNotes(evt.target.value)}
              placeholder={notesPlaceholder}
              maxLength={maxNotes}
            />
            {!!maxNotes && (
              <MenuItemInstructionsCounter>
                {(notes || '').length}/{maxNotes}
              </MenuItemInstructionsCounter>
            )}
          </MenuItemInstructionsInput>
        )}
        <MenuItemInstructionsFooter>
          <Button onClick={allDone}>{doneLabel}</Button>
        </MenuItemInstructionsFooter>
      </MenuItemInstructionsContainer>
    </MenuItemInstructionsView>
  )
}

export default MenuItemInstructions
